import { useMemo } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import PropTypes from "prop-types";

import DataTable from "@accredo/fe-shared/components/DataTable.jsx";
import BookingStatus from "../BookingStatus.jsx";
import { getEuro } from "@accredo/fe-shared/services/formatService.js";

export default function BookingExportBookingsTable({ bookings }) {
  const columns = useMemo(
    () => [
      { accessorKey: "recipient", header: "Empfänger", size: 180 },
      { accessorKey: "iban", header: "IBAN", size: 200 },
      { accessorKey: "description", header: "Verwendungszweck", size: 220 },
      {
        accessorKey: "amount",
        header: "Betrag",
        size: 120,
        muiTableHeadCellProps: { align: "right" },
        Cell: ({ cell }) => (
          <Typography variant="body2" sx={{ textAlign: "right" }}>
            {getEuro(cell.getValue())}
          </Typography>
        ),
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 120,
        Cell: ({ row }) => <BookingStatus booking={row.original} />,
      },
      {
        accessorKey: "schaden_id",
        header: "Schaden",
        size: 140,
        Cell: ({ cell, row }) => {
          const schadenId = cell.getValue();
          if (!schadenId) return null;

          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Typography variant="body2">
                {row.original.schaden?.schaden_nummer_accredo || schadenId}
              </Typography>
              <IconButton
                size="small"
                onClick={() =>
                  window.open(`/schaden/${schadenId}?tab=buchungen`, "_blank")
                }
              >
                <OpenInNew fontSize="small" />
              </IconButton>
            </Box>
          );
        },
      },
    ],
    []
  );

  return (
    <DataTable
      columns={columns}
      data={bookings}
      manualSorting={false}
      enableGlobalFilter={false}
      enableColumnFilters={false}
      enableTopToolbar={false}
      enablePagination={false}
    />
  );
}

BookingExportBookingsTable.propTypes = {
  bookings: PropTypes.array.isRequired,
};
